import React, { useState, useEffect } from 'react';

const HeroSection = ({ siteData, updateSiteData, setSiteData, showSaveStatus }) => {
    const [localHero, setLocalHero] = useState(siteData.hero);
    const [hasChanges, setHasChanges] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setLocalHero(siteData.hero);
        setHasChanges(false);
    }, [siteData.hero]);

    const handleLocalUpdate = (field, value) => {
        setLocalHero(prev => ({
            ...prev,
            [field]: value
        }));
        setHasChanges(true);
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setSiteData(prev => ({
                ...prev,
                hero: localHero
            }));

            await updateSiteData('hero', localHero);
            showSaveStatus('Hero section updated successfully!');
            setHasChanges(false);
        } catch (error) {
            console.error('Failed to update hero:', error);
            showSaveStatus('Failed to update hero section', true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-xl font-semibold text-stone-800">Hero Section</h3>
                <button
                    onClick={handleSave}
                    disabled={!hasChanges || saving}
                    className={`px-6 py-2 rounded-lg font-medium transition-colors ${hasChanges && !saving
                        ? 'bg-amber-500 text-white hover:bg-amber-600'
                        : 'bg-stone-300 text-stone-500 cursor-not-allowed'
                        }`}
                >
                    {saving ? 'Saving...' : hasChanges ? 'Save Changes' : 'No Changes'}
                </button>
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Title</label>
                <input
                    type="text"
                    value={localHero.title}
                    onChange={(e) => handleLocalUpdate('title', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Subtitle</label>
                <textarea
                    value={localHero.subtitle}
                    onChange={(e) => handleLocalUpdate('subtitle', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                    rows="3"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Button Text</label>
                <input
                    type="text"
                    value={localHero.buttonText}
                    onChange={(e) => handleLocalUpdate('buttonText', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                />
            </div>
        </div>
    );
};

export default HeroSection;